import './RIHeader.scss';
import { prefixClass } from 'lib/utils';
import { IconAttention, IconCalendar, IconBlocker, IconsInsightsQuestion } from 'components/Icons';
import classNames from 'classnames';
import { Tooltip, Whisper } from 'rsuite';
import { getDaysAgo } from '../../utils/dateUtils';
import { formatDate } from '../utils/formatDateQ';

export type requestType = 'request' | 'task' | 'event' | 'blocker';

export type RIHeaderProps = {
  userName: string;
  isKSUser?: boolean;
  locationName?: string;
  locationId?: string;
  date: string;
  requestType?: requestType;
  isMultiLocation?: boolean;
  title?: string;
  isInternal?: boolean;
  compact?: boolean;
};

const RIHeader: React.FC<RIHeaderProps> = ({
  userName,
  locationName,
  date,
  requestType,
  isMultiLocation = false,
  isKSUser = false,
  isInternal = false,
  compact = false,
}) => {
  // We calculate KAI from either the username or the userId. UserId = 4emD3RxpsUcnDgndL2vMbHryHJU2 is the hone admin user user
  const isKit = userName.toLowerCase() === 'kit' || userName.toLowerCase() === 'hone admin';

  // If userName is not provided, we default it to be a KS accountant
  const displayUserName = isKit ? 'KAI' : userName || 'KS accountant';

  // If locationName is not provided, use a default value. If it is a
  const displayLocationName = isMultiLocation && locationName && locationName !== '' ? locationName : null;

  // Local requestType component
  const RequestType = () => {
    if (!requestType) return null;
    return (
      <div className={classNames(prefix('request-type'), { [`rt-${requestType}`]: true })}>
        <div className={classNames(prefix('request-type-icon'), { blocker: requestType === 'blocker' })}>
          {requestType === 'request' ? (
            <IconsInsightsQuestion />
          ) : requestType === 'task' ? (
            <IconAttention />
          ) : requestType === 'blocker' ? (
            <IconBlocker />
          ) : (
            <IconCalendar />
          )}
        </div>
      </div>
    );
  };
  const prefix = prefixClass('ri-header');
  const formattedDate = formatDate(date);

  return (
    <div data-testid="request-item-header" className={prefix()}>
      <div className={prefix('info')}>
        <div className={prefix('info-user')}>
          <div className={prefix('info-user-name')}>{displayUserName}</div>
          {isKSUser && !isInternal && !compact && (
            <div className={prefix('info-user-ks')}>{isKit ? 'System' : 'Accountant'}</div>
          )}
        </div>
        <Whisper
          delayOpen={600}
          delayClose={100}
          placement="top"
          trigger="hover"
          speaker={<Tooltip>{getDaysAgo(date)}</Tooltip>}
        >
          <div className={prefix('info-date')}>{formattedDate}</div>
        </Whisper>
        {requestType && (
          <div className={prefix('info-request-type')}>
            <RequestType />
          </div>
        )}
      </div>
      {(compact || (isKSUser && isInternal)) && (
        <div className={prefix('info-user-internal-details')}>
          {isKSUser && <div className={prefix('info-user-ks')}>{isKit ? 'System' : 'Accountant'}</div>}
          {isInternal && <div className={prefix('info-user-internal')}>int</div>}
        </div>
      )}
      {displayLocationName && <div className={prefix('location')}>{locationName}</div>}
    </div>
  );
};

export default RIHeader;
